export enum MockMode {
  Off = 0,
  HappyPath,
  HappyDelayed,
  ServerErrors,
  ServerErrorsDelayed,
  Timeouts,
  RandomErrors,
  BadRequest400,
  Unauthorized401,
  Forbidden403
}
export const AllMockModes: MockMode[] = [
  MockMode.HappyPath,
  MockMode.HappyDelayed,
  MockMode.ServerErrors,
  MockMode.ServerErrorsDelayed,
  MockMode.Timeouts,
  MockMode.RandomErrors,
  MockMode.BadRequest400,
  MockMode.Unauthorized401,
  MockMode.Forbidden403
];

export enum MockUserMode {
  Default = 0,
  Minimal,
  Full,
  Alternate,
  EdgeCase
}
export const AllMockUserModes: MockUserMode[] = [
  MockUserMode.Default,
  MockUserMode.Minimal,
  MockUserMode.Full,
  MockUserMode.Alternate,
  MockUserMode.EdgeCase
];
